export default "__VITE_ASSET__fa82b39d__"